import React, { useEffect, useState } from "react";
import LoadingScreen from "./components/LoadingScreen";
import Navbar from "./components/Navbar";
import Main from "./pages/Main";
import { Helmet } from "react-helmet";
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <LoadingScreen />;

  return (
    <>
    <Helmet>
        <link rel="canonical" href="https://bluediamondrentcar.com/" />
        <meta name="robots" content="index, follow" />
      </Helmet>
<div>
      <Main />
    </div>
    </>
    
  );
}

export default App;
